const createFamiliesColorsState = (set) => ({
  familiesColors: null,
  setFamiliesColors: (data) => set({ familiesColors: data }),
});

export { createFamiliesColorsState };
